import { createBrowserRouter } from "react-router";

import {
    URL_BOARDS,
    URL_FORGOT_PASSWORD,
    URL_HOME,
    URL_LOGIN,
    URL_PROFILE,
    URL_REGISTER,
    URL_RESET_PASSWORD,
} from "@/constants/routes";

import { Planned } from "./Planned";
import { RootLayout } from "./RootLayout";

/**
 * Карта маршрутов. Здесь только пути и ленивые импорты экранов из `@/features/<name>` (index фичи):
 * без `loader`/`action` — данные загружает React Query (`docs/api-client.md`), а не роутер.
 *
 * Экран фичи подключается так:
 *
 * ```ts
 * { path: URL_LOGIN, lazy: () => import("@/features/auth").then((m) => ({ Component: m.LoginScreen })) }
 * ```
 *
 * Защищённая часть — layout-маршрут с `AuthGate` и оболочкой (`features/shell`, `DashboardLayout`),
 * внутри — `/`, `/boards`, `/boards/:boardId`, `/profile`. Ошибки рендера — `ErrorBoundary` маршрута.
 */
export const router = createBrowserRouter([
    {
        Component: RootLayout,
        children: [
            { path: "/share", lazy: () => import("@/features/board").then((m) => ({ Component: m.SharedEntry })) },
            // Шаг «Авторизация»: экраны `features/auth`.
            { path: URL_LOGIN, lazy: () => import("@/features/auth").then((m) => ({ Component: m.LoginScreen })) },
            {
                path: URL_REGISTER,
                lazy: () => import("@/features/auth").then((m) => ({ Component: m.RegisterScreen })),
            },
            { path: URL_FORGOT_PASSWORD, Component: Planned },
            { path: URL_RESET_PASSWORD, Component: Planned },
            { path: URL_PROFILE, lazy: () => import("@/features/auth").then((m) => ({ Component: m.ProfileScreen })) },
            // Account-owned boards; shared-link entry is added separately.
            { path: URL_HOME, lazy: () => import("@/features/boards").then((m) => ({ Component: m.BoardsScreen })) },
            { path: URL_BOARDS, lazy: () => import("@/features/boards").then((m) => ({ Component: m.BoardsScreen })) },
            {
                path: `${URL_BOARDS}/:boardId`,
                lazy: () => import("@/features/board").then((m) => ({ Component: m.BoardScreen })),
            },
            { path: "*", Component: Planned },
        ],
    },
]);
